import axios from "../../utils/axios";
// 获取列表
export function investorSubscriptionList(query) {
    return axios({
        url: "/admin/fund/investor/investorSubscriptionIndex",
        method: "get",
        params: query,
    });
}
